import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
import InsightBox from './InsightBox';


function DraftInsightsList({ draftId, insights, setSelectedTab }) {
    if (!insights || insights.length === 0) {
        return null;
    }

    return (
        <Stack spacing={1}>
            <Typography variant="bold" fontSize="16px">Preference Card Insights</Typography>
            {insights.map((insight, index) => (
                <InsightBox key={index} draftId={draftId} insight={insight} setSelectedTab={setSelectedTab} />
            ))}
        </Stack>
    );
}

export default DraftInsightsList;

